import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { NpmInitFunction, npmStartPrecheck, npmStopPrecheck, npmStartSessions, npmStopSessions, packageType } from '../../constant';
import GetStartedShell, { CodeCard, CopyButton, getStartedSteps } from '../GetStartedShell';

const NpmContent = () => {
	const [npmTypes, setNpmTypes] = useState('npm');
	const { t } = useTranslation();

	const handleCopy = (url) => {
		navigator.clipboard.writeText(url);
	};

	return (
		<GetStartedShell
			title={t('how_mereos_library_works')}
			description={t('mereos_library_hero_desc')}
			steps={getStartedSteps(t)}
		>
			<div className="library-page__panel">
				<h2 className="library-page__panel-title">{t('installation')}</h2>
				<p className="library-page__panel-text">{t('mereos_is_a_javaScript_library')}</p>
				<p className="library-page__panel-text">{t('npm_installation_intro')}</p>
				<p className="library-page__panel-text">{t('installation_command_intro')}</p>
				<CopyButton onCopy={() => handleCopy(packageType[npmTypes])} label={t('copy')} />
				<CodeCard
					tabs={(
						<div className="library-page__package-tabs">
							{['npm', 'yarn', 'pnpm'].map((type) => (
								<button
									key={type}
									type="button"
									className={`library-page__package-tab${npmTypes === type ? ' library-page__package-tab--active' : ''}`}
									onClick={() => setNpmTypes(type)}
								>
									{type}
								</button>
							))}
						</div>
					)}
				>
					{packageType[npmTypes]}
				</CodeCard>
			</div>

			<div className="library-page__panel">
				<h2 className="library-page__panel-title">{t('example_usage')}</h2>
				<p className="library-page__panel-text">{t('example_usage_intro')}</p>
			</div>

			<div className="library-page__panel" id="get-started-init">
				<h2 className="library-page__panel-title">{t('init_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_initiate')}</p>
				<CopyButton onCopy={() => handleCopy(NpmInitFunction)} label={t('copy')} />
				<CodeCard>{NpmInitFunction}</CodeCard>
				<p className="library-page__params-heading">{t('init_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">token</code>: {t('obtain_token_from_backend')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">candidate_object</code>: {t('candidate_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">external_id</code> {t('in_candidate_object_is_a_unique_id')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">profile_id</code>: {t('is_related_to_proctoring_profile')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">assessment_object</code>: {t('assessment_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">external_id</code> {t('in_assessment_object_is_the_id')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">theme_object</code>: {t('theme_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_init_note')}</li>
				</ul>
			</div>

			<div className="library-page__panel" id="get-started-prechecks">
				<h2 className="library-page__panel-title">{t('precheck_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_start_prechecks')}</p>
				<CopyButton onCopy={() => handleCopy(npmStartPrecheck)} label={t('copy')} />
				<CodeCard>{npmStartPrecheck}</CodeCard>
				<p className="library-page__params-heading">{t('precheck_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_precheck_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">session_resume</code>: {t('session_resume_key_description')}</li>
				</ul>
			</div>

			<div className="library-page__note">
				<span className="library-page__note-badge">
					<Info className="library-page__note-badge-icon" aria-hidden="true" />
					{t('optional_note_badge')}
				</span>
				<h2 className="library-page__note-title">{t('stop_precheck_step_title')}</h2>
				<p className="library-page__note-text">{t('function_is_used_to_stop_prechecks')}</p>
				<CopyButton onCopy={() => handleCopy(npmStopPrecheck)} label={t('copy')} />
				<CodeCard>{npmStopPrecheck}</CodeCard>
				<p className="library-page__params-heading">{t('stop_precheck_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_stop_precheck_note')}</li>
				</ul>
			</div>

			<div className="library-page__panel" id="get-started-start-session">
				<h2 className="library-page__panel-title">{t('start_session_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_start_the_session')}</p>
				<CopyButton onCopy={() => handleCopy(npmStartSessions)} label={t('copy')} />
				<CodeCard>{npmStartSessions}</CodeCard>
			</div>

			<div className="library-page__panel" id="get-started-stop-session">
				<h2 className="library-page__panel-title">{t('stop_session_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_finish_the_session')}</p>
				<CopyButton onCopy={() => handleCopy(npmStopSessions)} label={t('copy')} />
				<CodeCard>{npmStopSessions}</CodeCard>
			</div>
		</GetStartedShell>
	)
}

export default NpmContent
